"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSubreducer = void 0;
const handleSubreducer = (action, subreducer, lens) => (state) => {
    const fn = subreducer.methods[action.type];
    return fn ? lens.modify((current) => fn(current, action))(state) : state;
};
exports.handleSubreducer = handleSubreducer;
//# sourceMappingURL=subreducers.js.map